/**
 * 2026-09-26 FASE 6 COMPETENCIA oferta 8/9 T2 reduced-motion SSOT (research
 * 2026 MDN "prefers-reduced-motion" — página modificada 2026-06-10,
 * verificada vía webfetch 2026-09-26 — + WCAG 2.2 criterio 2.3.3 vestibular):
 * el chequeo `matchMedia("(prefers-reduced-motion: reduce)")` estaba copiado
 * inline en ~16 componentes con la misma guarda SSR. Una sola definición
 * SSR-safe (sin window o sin matchMedia → false, nunca throw) para que el
 * nuevo código no copie el inline otra vez. Sin cambio visual: los
 * consumidores migran con semántica idéntica. Fingerprint
 * `reduced-motion-ssot`.
 */

/** Media query SSOT para movimiento no esencial. */
export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * True cuando el usuario prefiere movimiento reducido. SSR-safe: fuera del
 * navegador o sin matchMedia devuelve false sin lanzar.
 */
export function prefersReducedMotion(): boolean {
  try {
    if (typeof window === "undefined") return false;
    if (typeof window.matchMedia !== "function") return false;
    return window.matchMedia(REDUCED_MOTION_QUERY).matches === true;
  } catch {
    return false;
  }
}
